export default "__VITE_ASSET__CyWY6$9T__"